export const allRolePermission = [
  {
    _id: "6718c0efbbfb9a50b0e4a1c8",
    roleId: {
      _id: "6718a331b256b60c65b4a04a",
      name: "admin7",
      role_id: 7,
      active: true,
      createdAt: "2024-10-23T07:18:09.949Z",
      updatedAt: "2024-10-23T07:18:09.949Z",
      __v: 0,
    },
    componentType: {
      _id: "6713a3828af955c2ce786a69",
      name: "Form",
      active: true,
      created_by: "66a8cb86308b9eb1bc8eb262",
      updated_by: null,
      createdAt: "2024-10-19T12:18:10.456Z",
      updatedAt: "2024-10-19T12:18:10.456Z",
      __v: 0,
    },
    component: {
      _id: "6718a26bb256b60c65b4a000",
      name: "menu_category",
      componentType: "6713a3828af955c2ce786a69",
      active: true,
      created_by: "66a8cb86308b9eb1bc8eb262",
      updated_by: "66a8cb86308b9eb1bc8eb262",
      createdAt: "2024-10-23T07:14:51.406Z",
      updatedAt: "2024-10-23T09:22:43.202Z",
      __v: 0,
    },
    permissions: [
      {
        permissionId: "67160438cf309747042b3ebf",
        permissionName: "Read",
        _id: "6718c0efbbfb9a50b0e4a1c9",
      },
      {
        permissionId: "67137a80ebe58f12dc6b6d67",
        permissionName: "Create",
        _id: "6718c0efbbfb9a50b0e4a1ca",
      },
      {
        permissionId: "67125cad21f35d044788fd56",
        permissionName: "Update",
        _id: "6718c0efbbfb9a50b0e4a1cb",
      },
    ],
    active: true,
    created_by: "66a8cb86308b9eb1bc8eb262",
    updated_by: null,
  },
  {
    _id: "6718dc39f66d006faea4238c",
    roleId: {
      _id: "6718a331b256b60c65b4a04a",
      name: "admin7",
      role_id: 7,
      active: true,
      createdAt: "2024-10-23T07:18:09.949Z",
      updatedAt: "2024-10-23T07:18:09.949Z",
      __v: 0,
    },
    componentType: {
      _id: "6713a3828af955c2ce786a69",
      name: "Form",
      active: true,
      created_by: "66a8cb86308b9eb1bc8eb262",
      updated_by: null,
      createdAt: "2024-10-19T12:18:10.456Z",
      updatedAt: "2024-10-19T12:18:10.456Z",
      __v: 0,
    },
    component: {
      _id: "6718dbedf66d006faea42353",
      name: "store_change",
      componentType: "6713a3828af955c2ce786a69",
      active: true,
      created_by: "66a8cb86308b9eb1bc8eb262",
      updated_by: null,
      createdAt: "2024-10-23T11:20:13.726Z",
      updatedAt: "2024-10-23T11:20:13.726Z",
      __v: 0,
    },
    permissions: [
      {
        permissionId: "67160438cf309747042b3ebf",
        permissionName: "Read",
        _id: "6718dc39f66d006faea4238d",
      },
      {
        permissionId: "67137a80ebe58f12dc6b6d67",
        permissionName: "Create",
        _id: "6718dc39f66d006faea4238e",
      },
      {
        permissionId: "67125cad21f35d044788fd56",
        permissionName: "Update",
        _id: "6718dc39f66d006faea4238f",
      },
    ],
    active: true,
    created_by: "66a8cb86308b9eb1bc8eb262",
    updated_by: null,
  },
  {
    _id: "671a1483786f6f04138905ce",
    roleId: {
      _id: "6718a331b256b60c65b4a04a",
      name: "admin7",
      role_id: 7,
      active: true,
      createdAt: "2024-10-23T07:18:09.949Z",
      updatedAt: "2024-10-23T07:18:09.949Z",
      __v: 0,
    },
    componentType: {
      _id: "6713a3578af955c2ce786a05",
      name: "Menu",
      active: true,
      created_by: "66a8cb86308b9eb1bc8eb262",
      updated_by: null,
      createdAt: "2024-10-19T12:17:27.409Z",
      updatedAt: "2024-10-19T12:17:27.409Z",
      __v: 0,
    },
    component: {
      _id: "6718de9108fbf95b6e001af7",
      name: "menu_subcategory",
      componentType: "6713a3578af955c2ce786a05",
      active: true,
      created_by: "66a8cb86308b9eb1bc8eb262",
      updated_by: null,
      createdAt: "2024-10-23T11:31:29.815Z",
      updatedAt: "2024-10-23T11:31:29.815Z",
      __v: 0,
    },
    permissions: [
      {
        permissionId: "67160438cf309747042b3ebf",
        permissionName: "Read",
        _id: "671a1483786f6f04138905cf",
      },
      {
        permissionId: "67137a80ebe58f12dc6b6d67",
        permissionName: "Create",
        _id: "671a1483786f6f04138905d0",
      },
    ],
    active: false,
    created_by: "66a8cb86308b9eb1bc8eb262",
    updated_by: null,
  },
];
